export default __webpack_public_path__ + "img/Inter-SemiBold_5940413.woff2";